const CalendarSync = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5002 7.50195V9.02195H10.9802" stroke="#3E3E40" />
    <path
      d="M12.5006 9.02202C12.0606 8.01631 11.1464 7.30774 9.97493 7.30774C8.8035 7.30774 7.79779 8.01631 7.35779 9.02202"
      stroke="#3E3E40"
    />
    <path d="M7.35779 12.8276V11.3076H8.87207" stroke="#3E3E40" />
    <path
      d="M7.35779 11.3076C7.79779 12.3133 8.71207 13.0219 9.8835 13.0219C11.0549 13.0219 12.0606 12.3133 12.5006 11.3076"
      stroke="#3E3E40"
    />
    <path d="M0.500488 3.30769H3.92906V1.02197H0.500488V3.30769Z" stroke="#3E3E40" />
    <path d="M3.92914 3.30769H7.35771V1.02197H3.92914V3.30769Z" stroke="#3E3E40" />
    <path d="M7.35779 3.30769H10.7864V1.02197H7.35779V3.30769Z" stroke="#3E3E40" />
    <path d="M10.7862 5.59345V3.30774H0.500488V11.3077H5.07192" stroke="#3E3E40" />
  </svg>
);

export default CalendarSync;
